import { runSyncOk } from '../commands/exec';

export default [
  runSyncOk('chromium', ['--version']) && 'chromium',
  runSyncOk('firefox', ['--version']) && 'firefox',
  // runSyncOk('livestreamer', ['--version']) && 'livestreamer', TODO checked dailymotion and Twitch, failed because json parsing or auth
  runSyncOk('omxplayer', ['--version']) && 'omxplayer',
].filter(Boolean);
